import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Picker as __unplugin_components_2 } from 'vant/es';
import 'vant/es/picker/style/index';
import { Popup as __unplugin_components_1 } from 'vant/es';
import 'vant/es/popup/style/index';
import { Field as __unplugin_components_0 } from 'vant/es';
import 'vant/es/field/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c(__unplugin_components_0, {
    attrs: {
      "value": _vm.fieldName,
      "is-link": "",
      "readonly": "",
      "label": _vm.label,
      "placeholder": i18n.tc("684") + _vm.label
    },
    on: {
      "click": function ($event) {
        _vm.showPicker = true;
      }
    }
  }), _c(__unplugin_components_1, {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: _vm.showPicker,
      callback: function ($$v) {
        _vm.showPicker = $$v;
      },
      expression: "showPicker"
    }
  }, [_c(__unplugin_components_2, {
    attrs: {
      "title": _vm.label,
      "show-toolbar": true,
      "columns": _vm.columns
    },
    on: {
      "cancel": function ($event) {
        _vm.showPicker = false;
      },
      "confirm": function ($event) {
        ;
        _vm.showPicker = false, _vm.$emit('confirm', $event);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };